// import React, { useEffect } from 'react';
// import emailjs from '@emailjs/browser';
// import { useLocation } from 'react-router-dom';
// import './servicePage.css';

// const ServicePage = ({ service }) => {
//   const location = useLocation();

//   // EmailJS Inquiry Form Handler
//   function handleInquirySubmit(e) {
//     e.preventDefault();
//     const form = e.target;
//     emailjs.send(
//       import.meta.env.VITE_APP_INQUIRY_EMAILJS_SERVICE_ID,
//       import.meta.env.VITE_APP_INQUIRY_EMAILJS_TEMPLATE_ID,
//       {
//         name: form['quote-name'].value,
//         phone: form['quote-phone'].value,
//         email: form['quote-email'].value,
//         service: form['quote-service'].value,
//         baths: form['quote-baths'].value,
//         area: form['quote-area'].value,
//         message: form['quote-message'].value,
//       },
//       import.meta.env.VITE_APP_EMAILJS_PUBLIC_KEY
//     ).then(
//       () => {
//         alert('Enquiry sent successfully!');
//         form.reset();
//       },
//       () => {
//         alert('Failed to send enquiry. Please try again.');
//       }
//     );
//   }

//   useEffect(() => {
//     // Scroll to top on route change
//     window.scrollTo(0, 0);
    
//     // Update page title for SEO
//     document.title = `${service.title} | Niks Elite Cleaning`;
    
//     // Update meta description
//     const metaDescription = document.querySelector('meta[name="description"]');
//     if (metaDescription) {
//       metaDescription.setAttribute('content', service.metaDescription);
//     }
//   }, [location, service]);

//   return (
//     <div className="service-page">
//       {/* Hero Section */}
//       <section className="service-hero" style={{backgroundImage: `url(${service.heroImage})`}}>
//         <div className="hero-overlay"></div>
//         <div className="container">
//           <div className="hero-content" data-aos="fade-up">
//             <h1>{service.h1}</h1>
//             <p className="hero-subtitle">{service.subtitle}</p>
//             <div className="hero-cta">
//               <a href="tel:+61493519401" className="btn btn-primary">
//                 <i className="fas fa-phone-alt"></i> Call Now
//               </a>
//               <a href="#contact" className="btn btn-secondary">Get Free Quote</a>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Main Content */}
//       <section className="service-content section-padding">
//         <div className="container">
//           <div className="content-grid">
//             {/* Main Article */}
//             <article className="service-article">
//               <h2 data-aos="fade-up">{service.whyChooseTitle}</h2>
//               <div className="content-text" data-aos="fade-up" data-aos-delay="100">
//                 {service.whyChooseContent}
//               </div>

//               <h2 data-aos="fade-up">{service.includedTitle}</h2>
//               <div className="included-list" data-aos="fade-up" data-aos-delay="100">
//                 <ul>
//                   {service.includedItems.map((item, index) => (
//                     <li key={index}>
//                       <i className="fas fa-check-circle"></i> {item}
//                     </li>
//                   ))}
//                 </ul>
//               </div>

//               {service.guarantee && (
//                 <>
//                   <h2 data-aos="fade-up">{service.guarantee.title}</h2>
//                   <div className="guarantee-box" data-aos="fade-up" data-aos-delay="100">
//                     <div className="guarantee-icon">
//                       <i className="fas fa-shield-alt"></i>
//                     </div>
//                     <div className="guarantee-content">
//                       {service.guarantee.content}
//                     </div>
//                   </div>
//                 </>
//               )}

//               <h2 data-aos="fade-up">Areas We Serve</h2>
//               <div className="service-areas" data-aos="fade-up" data-aos-delay="100">
//                 <p>{service.areasContent}</p>
//                 <div className="areas-grid">
//                   {service.serviceAreas.map((area, index) => (
//                     <div key={index} className="area-tag">
//                       <i className="fas fa-map-marker-alt"></i> {area}
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Service FAQs */}
//               <h2 data-aos="fade-up">Frequently Asked Questions</h2>
//               <div className="service-faqs" data-aos="fade-up" data-aos-delay="100">
//                 {service.faqs.map((faq, index) => (
//                   <div key={index} className="faq-item">
//                     <h3>{faq.question}</h3>
//                     <p>{faq.answer}</p>
//                   </div>
//                 ))}
//               </div>

//               {/* CTA Section */}
//               <div className="content-cta" data-aos="fade-up">
//                 <h3>Ready to Book {service.title}?</h3>
//                 <p>Call us now or fill out the form below for a free, no-obligation quote.</p>
//                 <div className="cta-buttons">
//                   <a href="tel:+61493519401" className="btn btn-primary">
//                     <i className="fas fa-phone-alt"></i> +61 493 519 401
//                   </a>
//                   <a href="#contact" className="btn btn-secondary">Request Free Quote</a>
//                 </div>
//               </div>
//             </article>

//             {/* Sidebar */}
//             <aside className="service-sidebar">
//               <div className="sidebar-widget" data-aos="fade-left">
//                 <h3>Quick Contact</h3>
//                 <div className="contact-info-compact">
//                   <div className="info-item">
//                     <i className="fas fa-phone-alt"></i>
//                     <div>
//                       <strong>Call Us</strong>
//                       <a href="tel:+61493519401">+61 493 519 401</a>
//                     </div>
//                   </div>
//                   <div className="info-item">
//                     <i className="fas fa-envelope"></i>
//                     <div>
//                       <strong>Email</strong>
//                       <a href="mailto:nikselitecleaning.vic@gmail.com">nikselitecleaning.vic@gmail.com</a>
//                     </div>
//                   </div>
//                   <div className="info-item">
//                     <i className="fas fa-clock"></i>
//                     <div>
//                       <strong>Hours</strong>
//                       <span>7 Days, 7AM - 7PM</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="sidebar-widget" data-aos="fade-left" data-aos-delay="100">
//                 <h3>Why Choose Us?</h3>
//                 <ul className="why-list">
//                   <li><i className="fas fa-star"></i> 5-Star Rated Service</li>
//                   <li><i className="fas fa-certificate"></i> Fully Insured</li>
//                   <li><i className="fas fa-leaf"></i> Eco-Friendly Products</li>
//                   <li><i className="fas fa-users"></i> Professional Team</li>
//                   <li><i className="fas fa-shield-alt"></i> 100% Guarantee</li>
//                 </ul>
//               </div>

//               <div className="sidebar-widget trust-badges" data-aos="fade-left" data-aos-delay="200">
//                 <div className="badge">
//                   <i className="fas fa-check-circle"></i>
//                   <span>1500+ Happy Customers</span>
//                 </div>
//                 <div className="badge">
//                   <i className="fas fa-star"></i>
//                   <span>5.0 Rating</span>
//                 </div>
//               </div>
//             </aside>
//           </div>
//         </div>
//       </section>

//       {/* Contact Form Section */}
//       <section id="contact" className="service-contact section-padding">
//         <div className="container">
//           <div className="section-title">
//             <h2>Get Your Free Quote</h2>
//             <p>Fill out the form below and we'll get back to you within <b>12 hours</b></p>
//           </div>
//           <div className="contact-form-wrapper">
//             <form className="service-form" onSubmit={handleInquirySubmit}>
//                 // EmailJS Inquiry Form Handler
//                 function handleInquirySubmit(e) {
//                   e.preventDefault();
//                   const form = e.target;
//                   emailjs.send(
//                     import.meta.env.VITE_APP_INQUIRY_EMAILJS_SERVICE_ID,
//                     import.meta.env.VITE_APP_INQUIRY_EMAILJS_TEMPLATE_ID,
//                     {
//                       name: form['quote-name'].value,
//                       phone: form['quote-phone'].value,
//                       email: form['quote-email'].value,
//                       service: form['quote-service'].value,
//                       baths: form['quote-baths'].value,
//                       area: form['quote-area'].value,
//                       message: form['quote-message'].value,
//                     },
//                     import.meta.env.VITE_APP_EMAILJS_PUBLIC_KEY
//                   ).then(
//                     () => {
//                       alert('Enquiry sent successfully!');
//                       form.reset();
//                     },
//                     () => {
//                       alert('Failed to send enquiry. Please try again.');
//                     }
//                   );
// }
//               <div className="form-row">
//                 <div className="form-group">
//                   <label htmlFor="quote-name">Your Name *</label>
//                   <input id="quote-name" type="text" placeholder="Enter your name" required />
//                 </div>
//                 <div className="form-group">
//                   <label htmlFor="quote-phone">Phone Number *</label>
//                   <input id="quote-phone" type="tel" placeholder="Enter your phone number" required />
//                 </div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label htmlFor="quote-email">Email Address *</label>
//                   <input id="quote-email" type="email" placeholder="Enter your email address" required />
//                 </div>
//                 <div className="form-group">
//                   <label htmlFor="quote-service">Select Service *</label>
//                   <select id="quote-service" required>
//                     <option value="">Select Service</option>
//                     <option value="end-of-lease">End of Lease Cleaning</option>
//                     <option value="carpet">Carpet Cleaning</option>
//                     <option value="domestic">Domestic Cleaning</option>
//                     <option value="commercial">Commercial Cleaning</option>
//                     <option value="office">Office Cleaning</option>
//                     <option value="window">Window Cleaning</option>
//                     <option value="other">Other</option>
//                   </select>
//                 </div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label htmlFor="quote-baths">Number of Baths *</label>
//                   <input id="quote-baths" type="number" min="1" placeholder="e.g. 2" required />
//                 </div>
//                 <div className="form-group">
//                   <label htmlFor="quote-area">Area (in Sq Ft) *</label>
//                   <input id="quote-area" type="number" min="1" placeholder="e.g. 1200" required />
//                 </div>
//               </div>
//               <div className="form-group">
//                 <label htmlFor="quote-message">Additional details or special requirements...</label>
//                 <textarea id="quote-message" placeholder="Tell us about your cleaning needs..." rows="5"></textarea>
//               </div>
//               <button type="submit" className="btn btn-primary btn-block">
//                 Send Inquiry <i className="fas fa-paper-plane"></i>
//               </button>
//             </form>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default ServicePage;


import React, { useEffect } from 'react';
import emailjs from '@emailjs/browser';
import { useLocation } from 'react-router-dom';
import SEO from '../seo/SEO';
import './servicePage.css';

const ServicePage = ({ service }) => {
  const location = useLocation();

  // EmailJS Inquiry Form Handler
  function handleInquirySubmit(e) {
    e.preventDefault();
    const form = e.target;

    console.log("ENV:", {
        service: process.env.VITE_APP_INQUIRY_EMAILJS_SERVICE_ID,
        template: process.env.VITE_APP_INQUIRY_EMAILJS_TEMPLATE_ID,
        pub: process.env.VITE_APP_EMAILJS_PUBLIC_KEY,
    });

    emailjs
      .send(
        "service_j88uc0v",
        "template_vyhdqlo",
        {
          name: form['quote-name'].value,
          phone: form['quote-phone'].value,
          email: form['quote-email'].value,
          service: form['quote-service'].value,
          bedrooms: form['quote-bedrooms'].value,
          baths: form['quote-baths'].value,
          area: form['quote-area'].value,
          message: form['quote-message'].value,
        },
        "hUq75JWL_H73HBNXu"
      )
.then((res) => {
    console.log("✅ EmailJS success:", res);
    alert("Enquiry sent successfully!");
    form.reset();
  })
  .catch((err) => {
    console.error("❌ EmailJS raw error:", err);
    console.error("❌ EmailJS JSON:", JSON.stringify(err, null, 2));

    // also show something useful on screen
    const msg =
      err?.text ||
      err?.message ||
      err?.status ||
      (typeof err === "string" ? err : null) ||
      "Unknown error (check console + Network tab)";

    alert(`Failed to send enquiry: ${msg}`);
  });
}

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <SEO 
        title={`${service.title} | Niks Elite Cleaning`}
        description={service.metaDescription}
      />
      <div className="service-page">
      {/* Hero Section */}
      <section
        className="service-hero"
        style={{ backgroundImage: `url(${service.heroImage})` }}
      >
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="hero-content" data-aos="fade-up">
            <h1>{service.h1}</h1>
            <p className="hero-subtitle">{service.subtitle}</p>
            <div className="hero-cta">
              <a href="tel:+61493519401" className="btn btn-primary">
                <i className="fas fa-phone-alt"></i> Call Now
              </a>
              <a href="#contact" className="btn btn-secondary">
                Get Free Quote
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="service-content section-padding">
        <div className="container">
          <div className="content-grid">
            {/* Main Article */}
            <article className="service-article">
              <h2 data-aos="fade-up">{service.whyChooseTitle}</h2>
              <div className="content-text" data-aos="fade-up" data-aos-delay="100">
                {service.whyChooseContent}
              </div>

              <h2 data-aos="fade-up">{service.includedTitle}</h2>
              <div className="included-list" data-aos="fade-up" data-aos-delay="100">
                <ul>
                  {service.includedItems.map((item, index) => (
                    <li key={index}>
                      <i className="fas fa-check-circle"></i> {item}
                    </li>
                  ))}
                </ul>
              </div>

              {service.guarantee && (
                <>
                  <h2 data-aos="fade-up">{service.guarantee.title}</h2>
                  <div className="guarantee-box" data-aos="fade-up" data-aos-delay="100">
                    <div className="guarantee-icon">
                      <i className="fas fa-shield-alt"></i>
                    </div>
                    <div className="guarantee-content">{service.guarantee.content}</div>
                  </div>
                </>
              )}

              <h2 data-aos="fade-up">Areas We Serve</h2>
              <div className="service-areas" data-aos="fade-up" data-aos-delay="100">
                <p>{service.areasContent}</p>
                <div className="areas-grid">
                  {service.serviceAreas.map((area, index) => (
                    <div key={index} className="area-tag">
                      <i className="fas fa-map-marker-alt"></i> {area}
                    </div>
                  ))}
                </div>
              </div>

              {/* Service FAQs */}
              <h2 data-aos="fade-up">Frequently Asked Questions</h2>
              <div className="service-faqs" data-aos="fade-up" data-aos-delay="100">
                {service.faqs.map((faq, index) => (
                  <div key={index} className="faq-item">
                    <h3>{faq.question}</h3>
                    <p>{faq.answer}</p>
                  </div>
                ))}
              </div>

              {/* CTA Section */}
              <div className="content-cta" data-aos="fade-up">
                <h3>Ready to Book {service.title}?</h3>
                <p>Call us now or fill out the form below for a free, no-obligation quote.</p>
                <div className="cta-buttons">
                  <a href="tel:+61493519401" className="btn btn-primary">
                    <i className="fas fa-phone-alt"></i> +61 493 519 401
                  </a>
                  <a href="#contact" className="btn btn-secondary">
                    Request Free Quote
                  </a>
                </div>
              </div>
            </article>

            {/* Sidebar */}
            <aside className="service-sidebar">
              <div className="sidebar-widget" data-aos="fade-left">
                <h3>Quick Contact</h3>
                <div className="contact-info-compact">
                  <div className="info-item">
                    <i className="fas fa-phone-alt"></i>
                    <div>
                      <strong>Call Us</strong>
                      <a href="tel:+61493519401">+61 493 519 401</a>
                    </div>
                  </div>
                  <div className="info-item">
                    <i className="fas fa-envelope"></i>
                    <div>
                      <strong>Email</strong>
                      <a href="mailto:nikselitecleaning.vic@gmail.com">
                        nikselitecleaning.vic@gmail.com
                      </a>
                    </div>
                  </div>
                  <div className="info-item">
                    <i className="fas fa-clock"></i>
                    <div>
                      <strong>Hours</strong>
                      <span>7 Days, 7AM - 7PM</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="sidebar-widget" data-aos="fade-left" data-aos-delay="100">
                <h3>Why Choose Us?</h3>
                <ul className="why-list">
                  <li>
                    <i className="fas fa-star"></i> 5-Star Rated Service
                  </li>
                  <li>
                    <i className="fas fa-certificate"></i> Fully Insured
                  </li>
                  <li>
                    <i className="fas fa-leaf"></i> Eco-Friendly Products
                  </li>
                  <li>
                    <i className="fas fa-users"></i> Professional Team
                  </li>
                  <li>
                    <i className="fas fa-shield-alt"></i> 100% Guarantee
                  </li>
                </ul>
              </div>

              <div className="sidebar-widget trust-badges" data-aos="fade-left" data-aos-delay="200">
                <div className="badge">
                  <i className="fas fa-check-circle"></i>
                  <span>1500+ Happy Customers</span>
                </div>
                <div className="badge">
                  <i className="fas fa-star"></i>
                  <span>5.0 Rating</span>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section id="contact" className="service-contact section-padding">
        <div className="container">
          <div className="section-title">
            <h2>Get Your Free Quote</h2>
            <p>
              Fill out the form below and we'll get back to you within <b>12 hours</b>
            </p>
          </div>
          <div className="contact-form-wrapper">
            <form className="service-form" onSubmit={handleInquirySubmit}>
              <div className="form-row">
                <div className="form-group">
                  {/* <label htmlFor="quote-name">Your Name *</label> */}
                  <input
                    id="quote-name"
                    name="quote-name"
                    type="text"
                    placeholder="Your Name"
                    required
                  />
                </div>
                <div className="form-group">
                  {/* <label htmlFor="quote-phone">Phone Number *</label> */}
                  <input
                    id="quote-phone"
                    name="quote-phone"
                    type="tel"
                    placeholder="Phone Number"
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  {/* <label htmlFor="quote-email">Email Address *</label> */}
                  <input
                    id="quote-email"
                    name="quote-email"
                    type="email"
                    placeholder="Email Address"
                    required
                  />
                </div>
                <div className="form-group">
                  {/* <label htmlFor="quote-service">Select Service *</label> */}
                  <select id="quote-service" name="quote-service" required>
                    <option value="">Select Service</option>
                    <option value="end-of-lease">End of Lease Cleaning</option>
                    <option value="carpet">Carpet Cleaning</option>
                    <option value="domestic">Domestic Cleaning</option>
                    <option value="commercial">Commercial Cleaning</option>
                    <option value="office">Office Cleaning</option>
                    <option value="window">Window Cleaning</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                {/* <label htmlFor="quote-bedrooms">Number of Bedrooms *</label> */}
                <input
                    id="quote-bedrooms"
                    name="quote-bedrooms"
                    type="number"
                    min="0"
                    placeholder="Number of Bedrooms"
                    required
                 />
               </div><br/>

              <div className="form-row">
                <div className="form-group">
                  {/* <label htmlFor="quote-baths">Number of Baths *</label> */}
                  <input
                    id="quote-baths"
                    name="quote-baths"
                    type="number"
                    min="1"
                    placeholder="Number of Baths"
                    required
                  />
                </div>
                <div className="form-group">
                  {/* <label htmlFor="quote-area">Area (in Sq M) *</label> */}
                  <input
                    id="quote-area"
                    name="quote-area"
                    type="number"
                    min="1"
                    placeholder="Area (in Sq M)"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                {/* <label htmlFor="quote-message">Additional details or special requirements...</label> */}
                <textarea
                  id="quote-message"
                  name="quote-message"
                  placeholder="Additional details or special requirements..."
                  rows="5"
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary btn-block">
                Send Inquiry <i className="fas fa-paper-plane"></i>
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
    </>
  );
};

export default ServicePage;